export function debounce(
  func: () => void,
  wait: number,
  timeout?: ReturnType<typeof setTimeout>,
) {
  if (timeout) {
    clearTimeout(timeout)
  }

  return setTimeout(func, wait)
}
